import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import {
  KNOWLEDGE_ATTENTION_FEATURE_OFF,
  KnowledgeAttentionParams,
  KnowledgeAttentionResponse,
} from 'src/app/models/home/knowledge-attention/knowledge-attention.model';
import { HOME_API_ROUTES } from './home-api-routes';

/**
 * Home IA · Radar de conocimiento R4 (ADR-HomeIA-R4). Una sola llamada por carga de /home al
 * agregador ACL-safe; ambos widgets (vencimientos + entidades) leen de esta respuesta. Ante 404
 * (plan sin `knowledge_hub`) devuelve la respuesta "feature off" para que la superficie se oculte
 * por completo, sin propagar el error. Los demás errores sí se propagan (los maneja el estado del
 * widget). account/user viajan por el JWT (interceptor); nunca como parámetros.
 */
@Injectable({ providedIn: 'root' })
export class HomeKnowledgeAttentionService {
  constructor(private readonly api: ApiService) {}

  getAttention(params?: KnowledgeAttentionParams): Observable<KnowledgeAttentionResponse> {
    return this.api
      .get<KnowledgeAttentionResponse>(HOME_API_ROUTES.KNOWLEDGE_ATTENTION, params)
      .pipe(
        catchError((error) => {
          // 404 = feature no disponible para el plan: ocultar la superficie, no es un error de UI.
          if (error?.status === 404) {
            return of(KNOWLEDGE_ATTENTION_FEATURE_OFF);
          }
          return throwError(() => error);
        }),
      );
  }
}
